import { takeLatest, call } from 'redux-saga/effects'
import * as fromActions from '../../actions/lessons-admin.action'
import { editLesson } from '../../../api/administration/lessons/Edit'
import { ILessonModel } from '../../../models/lesson.model'
import I18n from 'i18n'
import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'

async function handleEditLesson(lessonId: string, data: ILessonModel) {
  return await editLesson(lessonId, data)
}

function* editLessonEffectSaga(action: any) {
  try {
    const {
      payload: { lessonId, lessonData, history },
    } = action
    yield call(handleEditLesson, lessonId, lessonData)
    history.push(`/administration/courses/${lessonData.courseId}/lessons`)
    SuccessToast(I18n.t('administration.toastMessages.editSuccess'))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.editError'))
    console.log('error: ', error)
  }
}

export function* editLessonWatcherSaga() {
  yield takeLatest(fromActions.LESSON_EDIT, editLessonEffectSaga)
}
